export default __webpack_public_path__ + "static/media/jobshub-05-v1.d3ddbc8e.jpg";